import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const PE = () => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Introduction to Entrepreneurship and Innovation: Entrepreneurship: Concepts, entrepreneurship mindset, challenges; Innovation: What is innovation, role of technology, creating new ventures through innovative initiatives; Business opportunities: concepts & techniques for identifying opportunities, writing a problem statement, tools and techniques for idea generation; Introduction to social entrepreneurship. Study and Analyze at least three case studies of startups in computing (mixture of both successful and failed startups, an Indian startup, startup by a student).</p>
    </div>,
    <div key="2" className="p-4">
      <p>Understanding Business Model Canvas: Introduction to Business Model Canvas; customer segments; value proposition, distribution channels; Customer Relationship, Revenue Streams, Key Resources, Key Activities, Key Partnerships, Cost Structure, Preparing a business model canvas of a problem statement.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Finance and Marketing for early entrepreneurs: Basic understanding of P&L, Balance sheet and cash flow; Understanding of terms like CAGR, NPV, Angle funding, Venture capital, Debt funding, Equity, private equity, valuation, Break-even analysis, Return on Investment, Working Capital, Cost of Good Sold, Customer Acquisition cost, Customer life time value, profit margins. Marketing for budding entrepreneurs: Understanding customer requirements, Customer Profiling and segmentation, Marketing strategy, 4Ps of Marketing, Network effect.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Creating and writing a Business Plan: Introduction to different Business Models. Process of Business Planning - Purpose, structure and content, business plan outline, how to write Business plan, Preparing a business plan of a problem statement. Application of Business Model Canvas in creating the business plan. Understand customer needs, design and conduct a survey. Presentation of Business Plan. Process of incorporating a new company in India.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'youtube_playlist',
      label: 'Video Lectures',
      content: null, // Will be replaced in SubjectPage
    },
  ];

  return (
    <SubjectPage
      subjectName="Principles of Entrepreneurship Mindset"
      subjectKey="pe"
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'PENotes',
        videos: 'PEVideos'
      }}
    />
  );
};

export default PE;